function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "transportation",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_80",
  "data-name": "Path 80",
  d: "M19.459,138.268l-6.628.512a5.914,5.914,0,0,0-4.507,2.652L.681,152.992a4.1,4.1,0,0,0,2.79,6.308l6.068.94A54.341,54.341,0,0,1,19.459,138.268Z",
  transform: "translate(0 -117.23)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_81",
  "data-name": "Path 81",
  d: "M226.682,391.683l.94,6.068a4.093,4.093,0,0,0,6.308,2.79L245.49,392.9a5.914,5.914,0,0,0,2.651-4.507l.512-6.628A54.337,54.337,0,0,1,226.682,391.683Z",
  transform: "translate(-192.192 -323.723)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_82",
  "data-name": "Path 82",
  d: "M109.844,263.023a3.853,3.853,0,0,0,.634-.053,43.911,43.911,0,0,0,9.1-2.58L94.637,235.448a43.906,43.906,0,0,0-2.58,9.1,3.91,3.91,0,0,0,1.1,3.4l13.917,13.917A3.925,3.925,0,0,0,109.844,263.023Z",
  transform: "translate(-77.977 -199.55)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_83",
  "data-name": "Path 83",
  d: "M174.948,33.917c6.1-11.8,6.329-24.269,6.01-30.117A3.928,3.928,0,0,0,177.248.089C176.3.038,175.167,0,173.9,0c-6.539,0-16.886.99-26.765,6.1-7.85,4.061-18.145,13-24.218,24.752a2.254,2.254,0,0,1,.208.182l26.894,26.894a2.252,2.252,0,0,1,.181.208c11.75-6.073,20.691-16.368,24.752-24.218Zm-25.92-17.745a11.206,11.206,0,1,1-3.282,7.924,11.219,11.219,0,0,1,3.282-7.924Z",
  transform: "translate(-103.549)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M307.7,127.769a6.723,6.723,0,1,0-1.969-4.754,6.731,6.731,0,0,0,1.969,4.754Z",
  transform: "translate(-259.327 -98.643)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M2.546,354.764a2.233,2.233,0,0,0,1.585-.657l7.317-7.317a2.241,2.241,0,1,0-3.17-3.17L.961,350.938a2.241,2.241,0,0,0,1.585,3.826Z",
  transform: "translate(-0.259 -290.929)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M17.9,388.5a2.241,2.241,0,0,0-3.17,0L.66,402.57a2.241,2.241,0,1,0,3.17,3.169L17.9,391.672a2.241,2.241,0,0,0,0-3.17Z",
  transform: "translate(-0.003 -328.896)",
  fill: "#707070"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_87",
  "data-name": "Path 87",
  d: "M98.04,433.383,90.723,440.7a2.241,2.241,0,1,0,3.169,3.169l7.317-7.317a2.241,2.241,0,1,0-3.169-3.169Z",
  transform: "translate(-76.402 -367.072)",
  fill: "#707070"
}));

function SvgTransportation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.5,
    height: 77.5,
    viewBox: "0 0 77.5 77.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportation);
export default __webpack_public_path__ + "static/media/transportation.95f33b27.svg";
export { ForwardRef as ReactComponent };